/**
 * V70 Phase 3-C — 서버 중심 플레이 Feature Flag
 *
 * 이 flag 가 ON 일 때만 신규 서버 Callable (marbleRollDice, consumeAcidRainSession 등) 를
 * 공식 사용량·점수 경로로 사용. OFF 상태에서는 기존 localStorage mock 동작 유지.
 *
 * **이중 안전장치** (운영 보호 — 사용자 지시 §3 "운영의 기존 게임 동작은 변경하지 말 것"):
 *   1. 환경변수 `REACT_APP_PHASE_3C_SERVER === 'true'`
 *   2. Firebase projectId === 'ngle-worksqa'  (QA 전용)
 *   → 두 조건 모두 통과해야 enable. 운영 project 에서는 flag env 가 켜져 있어도 OFF.
 *
 * Phase 3-D (운영 롤아웃) 때 조건 2 를 완화하거나 운영 projectId 추가.
 */

const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const ENV = process.env.REACT_APP_ENV;

const QA_PROJECT_ID = 'ngle-worksqa';

/**
 * Phase 3-C 서버 플레이 Flag.
 *
 * 반환:
 *   - true  — 신규 서버 Callable 사용 (QA 전용)
 *   - false — 기존 localStorage mock 유지 (운영 포함 그 외 전부)
 */
export function isPhase3cServerEnabled(): boolean {
  // 테스트 환경 — 기본 OFF (기존 테스트 호환). 테스트별로 override 필요하면
  // 테스트에서 env 변수 설정 후 Jest moduleReset 사용.
  if (process.env.NODE_ENV === 'test') return false;

  // 환경변수 flag — .env.qa 에만 추가
  const envFlagOn = process.env.REACT_APP_PHASE_3C_SERVER === 'true';
  if (!envFlagOn) return false;

  // 운영 보호 — projectId 가 QA 이어야만 ON
  if (PROJECT_ID !== QA_PROJECT_ID) return false;

  return true;
}

/**
 * 디버그/UI 표시용 — 현재 상태를 라벨로 반환.
 */
export function getPhase3cServerStatusLabel(): string {
  if (process.env.NODE_ENV === 'test') return 'test';
  if (PROJECT_ID !== QA_PROJECT_ID) return `off (project=${PROJECT_ID || 'unknown'})`;
  const envFlagOn = process.env.REACT_APP_PHASE_3C_SERVER === 'true';
  return envFlagOn ? `on (env=${ENV})` : `off (env=${ENV}, flag=unset)`;
}
